// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__45fBn","logo":"style_logo__B1qLs"};